import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages'
import { OverTimeEntity } from './over-time.entity';
import { OvertimeController } from './over-time.controller';
import { OvertimeService } from './over-time.service';
import { OverTimeAdapter } from './dto/over-time.adapter';
import { AttendanceService } from '@gtpl/shared-services/hrms';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { EmployeeService } from '@gtpl/shared-services/masters';
import { OverTimeRepository } from './over-time.repository';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';

@Module({
    imports: [
        TypeOrmModule.forFeature([OverTimeRepository]),
    ],
    controllers: [OvertimeController],
    providers: [OvertimeService, OverTimeAdapter, ApplicationExceptionHandler, AttendanceService, WhatsAppNotificationService, EmployeeService,WhatsappBroadCastService],
    exports: [OvertimeService]
})
export class OvertimeModule { }
